import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { Demo } from './components/Demo';
import { Formats } from './components/Formats';
import { Integrations } from './components/Integrations';
import { Footer } from './components/Footer';
import './App.css';

/**
 * Main application component for the Intelligent Electron landing page.
 */
export function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <Demo />
        <Formats />
        <Integrations />
      </main>
      <Footer />
    </>
  );
}
